import {
    ListItemButton as MuiListItemButton,
    RadioGroup as MuiRadioGroup,
    styled,
} from "@mui/material"

import { L2RRadioButton } from "../L2RRadioButton"

export const RadioGroup = styled(MuiRadioGroup)(({
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
}))

export const Radio = styled(L2RRadioButton)({
    marginLeft: "auto",
})

export const Typography = styled("div")(({ theme, variant }) => ({
    alignSelf: "stretch",
    alignItems: "center",
    display: "flex",
    marginLeft: theme.spacing(8),
    fontWeight: theme.typography[variant].fontWeight,
}))

export const ListItemButton = styled(MuiListItemButton, {
    shouldForwardProp: (prop) => prop !== "isDisabled",
})(({ isDisabled, selected, theme }) => {

    const backgroundColor = isDisabled ? "action/disabledBackground"
        : selected ? "primary/_states/hover"
            : "common/white_states"

    return ({
        "&:hover": {
            backgroundColor: isDisabled ? `${theme.palette["action/disabledBackground"].main} !important`
                : `${theme.palette["common/gray_states"].light} !important`,
        },
        "&:active": {
            backgroundColor: isDisabled && `${theme.palette["action/disabledBackground"].main} !important`,
        },
        backgroundColor: `${theme.palette[backgroundColor].main} !important`,
        border: `2px solid ${selected ? theme.palette["primary"].main : theme.palette["common/white_states"].main}`,
        borderRadius: 12,
        cursor: isDisabled ? "default" : "pointer",
        display: "flex",
        fontSize: selected ? theme.typography["Desktop & Mobile/Heading/H3"].fontSize : theme.typography["Desktop & Mobile/Body/Regular"].fontSize,
        fontWeight: selected ? theme.typography["Desktop & Mobile/Heading/H3"].fontWeight : theme.typography["Desktop & Mobile/Body/Regular"].fontWeight,
        justifyContent: "space-between",
        height: "fit-content",
        opacity: isDisabled && "1 !important",
        padding: theme.spacing(1, 4),
        width: "100%",
    })
})